<template>
  <TagHub :slugs="[route.params.slug, route.params.other]" />
</template>

<script setup>
  // Remount per pair and page, so following a tag link fetches it.
  definePageMeta({ key: (route) => route.fullPath })

  const route = useRoute()
</script>
